import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  readonly SCREEN_ID = 'O80';

  public status: number;
  public message: string;

  constructor(private activatedRoute: ActivatedRoute, private translateService: TranslateService) {
  }

  ngOnInit() {
    // TODO 定数の管理方法を検討
    this.status = +this.activatedRoute.snapshot.params['status'];
    if (isNaN(this.status)) {
      // URLメールの有効期限切れ時メッセージ
      if (this.activatedRoute.snapshot.params['status'] === 'invalid-mail') {
        this.translateService.get('ERR_INVALID_URL').subscribe((res: string) => {
          this.message = res;
        });
        return;
      }

      this.status = 404;
    }

    // TODO メッセージの管理方法を検討
    switch (this.status) {
      case 500:
      case 403:
      case 400:
        this.translateService.get('ERR_400').subscribe((res: string) => {
          this.message = res;
        });
        break;
      case 401:
        this.translateService.get('ERR_401').subscribe((res: string) => {
          this.message = res;
        });
        break;
      case 404:
      default:
        this.translateService.get('ERR_404').subscribe((res: string) => {
          this.message = res;
        });
    }

    this.config();

    gtag('config', environment.analyticsId, {
      'page_path': '/error/' + this.status,
      'page_title': 'error_' + this.status
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'error_' + this.status,
      'page_location': '/error/' + this.status
    });

    // 検索インデックス登録ブロック用metaタグをhead内に埋め込む
    const noindexTag = document.createElement('meta');
    noindexTag.setAttribute('name', 'robots');
    noindexTag.setAttribute('content', 'noindex');
    const head = document.getElementsByTagName('head').item(0);
    head.appendChild(noindexTag);
  }

  /**
  * 共通初期設定
  */
  config() {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.analyticsId;
    document.getElementById('gaid').appendChild(script);
  }

}
